module.exports = __webpack_public_path__ + "img/2_161.9371719f.png";